// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "screen and (max-width: 320px)";
var _4 = "contacts-7pLht";
var _5 = "header-3sUrD";
var _6 = "form__container-ptY9U";
var _7 = "form-3lUA1";
var _8 = "description-3IwLo";
var _9 = "description__content-3dImG";
var _a = "edit-1uGUv";
var _b = "fields-fz2Yq";
var _c = "field-1TFmG";
var _d = "short-3r37O";
var _e = "field__contact-IRJ3H";
var _f = "description__header-tmpN0";
var _10 = "icon_success-3vpPR";
var _11 = "icon_notifications-1GmAz";
var _12 = "description__text-XmPvV";
var _13 = "customer__info-2Dly4";
var _14 = "footer-18w4S";
var _15 = "footer_centered-2rVtC";
var _16 = "footer__text-1x5d1";
var _17 = "footer__slideBottom-ibUEd";
var _18 = "footer__inner-2gMOI";
var _19 = "footer__social-33wdJ";
var _1a = "footer__social__button-wFfwk";
var _1b = "additional-372av";
var _1c = "checkbox-2WY1X";
var _1d = "checkbox_checked-2rZ7T";
var _1e = "checkbox__label-1LKsp";
var _1f = "footer__timerIcon-3AYno";
var _20 = "footer_login-2cY49";
var _21 = "footer__action-3vxDe";
var _22 = "code__wrapper-3Y1pP";
var _23 = "footer__input-2RM2l";
var _24 = "toggle-25VA6";
var _25 = "toggle_opened-1gj5X";
var _26 = "loader-1lpk-";
var _27 = "rotation-oqBI2";
var _28 = "welcome-1DXtT";
export { _1 as "__esModule", _2 as "mobile", _3 as "iphone5", _4 as "contacts", _5 as "header", _6 as "form__container", _7 as "form", _8 as "description", _9 as "description__content", _a as "edit", _b as "fields", _c as "field", _d as "short", _e as "field__contact", _f as "description__header", _10 as "icon_success", _11 as "icon_notifications", _12 as "description__text", _13 as "customer__info", _14 as "footer", _15 as "footer_centered", _16 as "footer__text", _17 as "footer__slideBottom", _18 as "footer__inner", _19 as "footer__social", _1a as "footer__social__button", _1b as "additional", _1c as "checkbox", _1d as "checkbox_checked", _1e as "checkbox__label", _1f as "footer__timerIcon", _20 as "footer_login", _21 as "footer__action", _22 as "code__wrapper", _23 as "footer__input", _24 as "toggle", _25 as "toggle_opened", _26 as "loader", _27 as "rotation", _28 as "welcome" }
export default { "__esModule": _1, "mobile": _2, "iphone5": _3, "contacts": _4, "header": _5, "form__container": _6, "form": _7, "description": _8, "description__content": _9, "edit": _a, "fields": _b, "field": _c, "short": _d, "field__contact": _e, "description__header": _f, "icon_success": _10, "icon_notifications": _11, "description__text": _12, "customer__info": _13, "footer": _14, "footer_centered": _15, "footer__text": _16, "footer__slideBottom": _17, "footer__inner": _18, "footer__social": _19, "footer__social__button": _1a, "additional": _1b, "checkbox": _1c, "checkbox_checked": _1d, "checkbox__label": _1e, "footer__timerIcon": _1f, "footer_login": _20, "footer__action": _21, "code__wrapper": _22, "footer__input": _23, "toggle": _24, "toggle_opened": _25, "loader": _26, "rotation": _27, "welcome": _28 }
